import { atom } from 'jotai';

export const isReadyBuyButtonAtom = atom(false);
export const buyButtonLoadingAtom = atom(true);
